
export default {
  name: 'AdminPromotionManage',
  data () {
    return {
      loading: false,
      saving: false,
      promotions: [],
      products: [],
      gifts: [],
      showAddModal: false,
      editingPromotion: null,
      showDeleteConfirm: false,
      deleteTargetId: null,
      form: {
        name: '',
        banner_image: '',
        start_date: '',
        end_date: '',
        status: 'active',
        gift_rule: 'same',
        buy_quantity: 1,
        gift_quantity: 1,
        gift_product_id: '',
        gift_id: '',
        productIds: []
      }
    }
  },
  computed: {
    availableProducts () {
      return this.products.filter(p => !this.form.productIds.includes(p.id))
    }
  },
  created () {
    this.fetchPromotions()
    this.fetchProducts()
    this.fetchGifts()
  },
  methods: {
    async fetchPromotions () {
      this.loading = true
      try {
        const res = await this.axios.get('/admin/promotions')
        if (res.data.code === 200) {
          this.promotions = res.data.data
          // 获取每个活动的商品数量
          for (const promo of this.promotions) {
            const productsRes = await this.axios.get(`/admin/promotions/${promo.id}/products`)
            if (productsRes.data.code === 200) {
              this.$set(promo, 'product_count', productsRes.data.data.length)
            }
          }
        }
      } catch (err) {
        console.error('获取促销活动失败:', err)
        this.$toast?.fail?.('获取活动列表失败')
      } finally {
        this.loading = false
      }
    },
    async fetchProducts () {
      try {
        const res = await this.axios.get('/admin/gift-products')
        if (res.data.code === 200) {
          this.products = res.data.data
        }
      } catch (err) {
        console.error('获取商品列表失败:', err)
      }
    },
    async fetchGifts () {
      try {
        const res = await this.axios.get('/admin/gifts')
        if (res.data.code === 200) {
          this.gifts = res.data.data
        }
      } catch (err) {
        console.error('获取赠品列表失败:', err)
      }
    },
    async fetchPromotionProducts (promotionId) {
      try {
        const res = await this.axios.get(`/api/admin/promotions/${promotionId}/products`)
        if (res.data.code === 200) {
          return res.data.data.map(p => p.product_id)
        }
      } catch (err) {
        console.error('获取活动商品失败:', err)
      }
      return []
    },
    getProductName (productId) {
      const product = this.products.find(p => p.id === productId)
      return product ? product.name : productId
    },
    addProduct (productId) {
      if (productId && !this.form.productIds.includes(productId)) {
        this.form.productIds.push(productId)
      }
    },
    removeProduct (productId) {
      this.form.productIds = this.form.productIds.filter(id => id !== productId)
    },
    async editPromotion (promo) {
      this.editingPromotion = promo
      const productIds = await this.fetchPromotionProducts(promo.id)
      this.form = {
        name: promo.name,
        banner_image: promo.banner_image || '',
        start_date: promo.start_date || '',
        end_date: promo.end_date || '',
        status: promo.status || 'active',
        gift_rule: promo.gift_rule || 'same',
        buy_quantity: promo.buy_quantity || 1,
        gift_quantity: promo.gift_quantity || 1,
        gift_product_id: promo.gift_product_id || '',
        gift_id: promo.gift_id || '',
        productIds: productIds
      }
    },
    async savePromotion () {
      if (!this.form.name.trim()) {
        this.$toast?.fail?.('请输入活动名称')
        return
      }
      if (this.saving) return

      this.saving = true
      try {
        const data = {
          name: this.form.name,
          bannerImage: this.form.banner_image,
          startDate: this.form.start_date,
          endDate: this.form.end_date,
          status: this.form.status,
          giftRule: this.form.gift_rule || null,
          buyQuantity: this.form.buy_quantity,
          giftQuantity: this.form.gift_quantity,
          giftProductId: this.form.gift_product_id || null,
          giftId: this.form.gift_id || null,
          productIds: this.form.productIds
        }

        if (this.editingPromotion) {
          await this.axios.put(`/admin/promotions/${this.editingPromotion.id}`, data)
          this.$toast?.success?.('活动已更新')
        } else {
          await this.axios.post('/admin/promotions', data)
          this.$toast?.success?.('活动已创建')
        }
        this.closeModal()
        this.fetchPromotions()
      } catch (err) {
        console.error('保存失败:', err)
        this.$toast?.fail?.('保存失败')
      } finally {
        this.saving = false
      }
    },
    confirmDelete (id) {
      this.deleteTargetId = id
      this.showDeleteConfirm = true
    },
    async doDelete () {
      if (!this.deleteTargetId) return

      try {
        await this.axios.delete(`/admin/promotions/${this.deleteTargetId}`)
        this.$toast?.success?.('活动已删除')
        this.showDeleteConfirm = false
        this.fetchPromotions()
      } catch (err) {
        console.error('删除失败:', err)
        this.$toast?.fail?.('删除失败')
      } finally {
        this.deleteTargetId = null
      }
    },
    closeModal () {
      this.showAddModal = false
      this.editingPromotion = null
      this.form = {
        name: '',
        banner_image: '',
        start_date: '',
        end_date: '',
        status: 'active',
        gift_rule: 'same',
        buy_quantity: 1,
        gift_quantity: 1,
        gift_product_id: '',
        gift_id: '',
        productIds: []
      }
    },
    chooseBannerImage () {
      this.$refs.bannerInput?.click()
    },
    async onBannerSelected (e) {
      const file = e.target.files[0]
      if (!file) return

      if (file.size > 5 * 1024 * 1024) {
        this.$toast?.fail?.('图片大小不能超过5MB')
        return
      }

      const formData = new FormData()
      formData.append('file', file)
      formData.append('purpose', 'banner')

      try {
        const res = await this.axios.post('/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        if (res.data.code === 200 && res.data.data?.url) {
          this.form.banner_image = res.data.data.url
          this.$toast?.success?.('上传成功')
        }
      } catch (err) {
        console.error('上传失败:', err)
        this.$toast?.fail?.('图片上传失败')
      }

      e.target.value = ''
    },
    giftRuleText (promo) {
      const ruleMap = {
        same: `买${promo.buy_quantity}送${promo.gift_quantity}同款`,
        sku: `买${promo.buy_quantity}送${promo.gift_quantity}其他商品`,
        gift: `买${promo.buy_quantity}送${promo.gift_quantity}赠品`
      }
      return ruleMap[promo.gift_rule] || ''
    },
    formatDate (date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    }
  }
}
